module.exports = {"150525100":"大沁他拉镇","150525101":"八仙筒镇","150525102":"青龙山镇","150525103":"新镇","150525104":"治安镇","150525105":"东明镇","150525106":"沙日浩来镇","150525107":"义隆永镇","150525200":"固日班花苏木","150525201":"白音他拉苏木","150525202":"明仁苏木","150525203":"黄花塔拉苏木","150525204":"土城子乡","150525205":"苇莲苏乡","150525400":"国有六号农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150525.json
// module id = 387
// module chunks = 0